/* 热门排行榜 */
import React from 'react'
import get from 'lodash/get'
import fetch from 'isomorphic-unfetch'

import getUrl from 'lib/url'
import getLinkHref from 'lib/get-link-href'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { useCityName } from 'Components/hooks'

import Header from './header'
import CarList from './car-list'

import { ICarList } from '../interface'

// getUrl('/motor/car_show/v1/get_rank/?offset=0&limit=3')

export default function PopularLeaderboard() {
  const [data, setData] = React.useState<ICarList[]>([])
  const cityName = useCityName()
  React.useEffect(() => {
    if (typeof cityName === 'undefined') {
      return
    }
    fetch(
      getUrl(
        `/motor/car_show/v1/get_rank/?rank_type=100&offset=0&limit=3&city_name=${encodeURIComponent(
          cityName
        )}`
      )
    )
      .then(res => res.json())
      .then(json => {
        const data = get(json, 'data', [])
        setData(Array.isArray(data) ? data : [])
      })
  }, [cityName])
  return (
    <div className="hotspot">
      <Header
        leftContent="热门排行榜"
        rightContent="总榜单"
        href="/leaderboard/popular"
        as={getLinkHref('/popular')}
        onClick={() => {
          sendTeaCommEvent('click_hot_series_rank_list_more')
        }}
      />
      <div className="list">
        {data.map((item: ICarList, index: number) => (
          <CarList
            list={item}
            key={item.series_name}
            from="click_hot_series_rank_list"
            index={index + 1}
          />
        ))}
      </div>
      <style jsx>
        {`
          .hotspot {
            margin-bottom: 10px;
            border: 1px solid #e6e6e6;
          }
          .list {
            padding-bottom: 16px;
          }
        `}
      </style>
    </div>
  )
}
